import CreditAlertPanel from "./creditAlertPanel.container";

export default CreditAlertPanel;
